import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderMenuComponent } from './slider-menu.component';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzElementPatchModule } from 'ng-zorro-antd/core/element-patch';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MenuComponent } from './menu/menu.component';
import { IconModule } from '../icons/icon/icon.module';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';

@NgModule({
  declarations: [SliderMenuComponent, MenuComponent, BreadcrumbComponent],
  imports: [
    CommonModule,
    NzMenuModule,
    NzToolTipModule,
    NzIconModule,
    IconModule,
    RouterModule.forRoot([]),
    NzElementPatchModule,
    NzBreadCrumbModule,
  ],
  exports: [SliderMenuComponent],
})
export class SliderMenuModule {}
